import {Container, Modal} from "react-bootstrap";
import "./main.scss"
import "aos/dist/aos.css";
import "bootstrap/dist/css/bootstrap.min.css";
import CountUp from "react-countup";
import {useInView} from "react-intersection-observer";
import VideoSection from "./video-section";
import FeaturedProperties from "./featured-properties";
import DeveloperParallax from "./developer-parallax";
import WorkWithUs from "./work-with-us-parallax";
import BlogSection from "./blog-section";
import React, {useContext, useState} from "react";
import SubscribeForm from "./subscribe-form";
import {DeviceContext, DeviceContextState} from "../../shared/services/device-context/device-context";
import {DeviceType} from "../../shared/services/device-context/device-context-vars";
import {useNavigate} from "react-router-dom";
import EventRegistrationForm from "../event/event-registration-form/event-registration-form.tsx";

interface MainState {
}

function Main() {

    const {ref, inView} = useInView({
        triggerOnce: true,
        threshold: 0.5,
    });

    const [subscribeModal, setSubscribeModal] = useState<boolean>(false);

    const device: DeviceContextState  = useContext(DeviceContext);

    const navigate = useNavigate();

    const navigateToURL = (url: string) => {
        navigate(`/${url}`);
    }

    return (
        <>
            <VideoSection />

            <Container fluid className={"container-sticky main-intro"}>
                <h2 className={"heading"}>MEET DUBAI'S #1 LUXURY REAL ESTATE AGENTS</h2>
                <h4 className={"sub-heading"}>IN THE LAST 3 YEARS</h4>
                <h4 className={"desc"}>With a proven track record of over AED 2 billion in real estate transactions <br/> Offering strategic insights to diversify portfolios, maximize returns, and build long-term wealth.</h4>
            </Container>

            {/* About luxora section */}
            <Container fluid className={"container-sticky mission-container"}>
                <div className={"mission-image"}>
                    <img src={"/Samples/developer1.jpg"} alt="" />
                </div>
                <div className={"mission-statement"}>
                    <h2 className={"heading"}>ABOUT LUXORA DUBAI</h2>
                    <div className={"mission-content"}>
                        <p>
                        At Luxora Dubai, Our mission is to bridge the gap between international investors, especially those in the U.S. and Dubai’s thriving real estate market. 
                        We aim to provide unparalleled access, expert guidance, and high-yield opportunities in one of the world’s fastest-growing and most investor-friendly real estate markets.
                        </p>
                        <br />
                        <p>
                        We believe that diversification is key to building long-term financial stability. 
                        Relying solely on U.S. real estate means tying your assets to one economy, which comes with risks such as market downturns, increasing tax burdens, and strict regulations. 
                        By investing in Dubai, you’re expanding your portfolio globally, gaining exposure to a booming, independent economy that offers high returns, financial security, and long-term growth.
                        </p>
                    </div>

                    <div className={"mission-bottom"}>
                        <hr style={{marginBottom: "1em", paddingBottom: "1em"}} />
                        <button className={"mission-learn-more-btn"} onClick={() => navigateToURL("about-us")}>
                            LEARN MORE
                        </button>
                    </div>
                </div>
            </Container>


            {/* Stats section */}
            <Container fluid ref={ref} className={"container-sticky align-items-center stats"}>
                <div className={"counter-item"}>
                    <h2 className={"counter-count"}>
                        ${inView ? <CountUp start={0} end={2} duration={2}/> : 0}B+
                    </h2>
                    <p className={"counter-text"}>worth of properties sold every year</p>
                </div>

                <div className={"counter-item"}>
                    <h2 className={"counter-count"}>
                        {inView ? <CountUp start={0} end={30} duration={3}/> : 0}+
                    </h2>
                    <p className={"counter-text"}>realtors and marketing professionals</p>
                </div>

                <div>
                    <h2 className={"counter-count"}>
                        {inView ? <CountUp start={0} end={10} duration={3}/> : 0}+
                    </h2>
                    <p className={"counter-text"}>years experience in Dubai real estate</p>
                </div>

                <div>
                    <h2 className={"counter-count"}>
                        {inView ? <CountUp start={1000} end={2500} duration={3}/> : 0}+
                    </h2>
                    <p className={"counter-text"}>clients served till date</p>
                </div>
            </Container>

            <Container fluid style={{
                padding: "0",
                margin: "0",

            }} className={"container-sticky align-items-center"}>
                <DeveloperParallax />
            </Container>

            <Container fluid className={"container-sticky align-items-center"}>
                <FeaturedProperties />
            </Container>

            <Container fluid className={"container-sticky align-items-center blogs"}>
                <BlogSection />
            </Container>

            <Container fluid className={"container-sticky align-items-center"} style={{
                padding: "0",
            }}>
                <WorkWithUs />
            </Container>

            <Container fluid className={"container-sticky align-items-center subscribe"}>
                <div className={"stay-updated"}>
                    <div className={"left"}>
                        <h4>STAY</h4>
                        <h4>AHEAD</h4>
                    </div>

                    <div className={"desc"}>
                        <p>Get exclusive access to Dubai’s most sought-after properties, expert insights, and early investment opportunities — delivered directly to your inbox.
                        From off-plan launches and market trends to insider tips on where to invest next, Luxora keeps you informed, ahead of the curve, and ready to make your next bold move.</p>
                    </div>

                    <div className={"stay-updated-btn"}>
                        <button className={"stay-updated-btn-subscribe"} onClick={() => {
                            setSubscribeModal(true);
                        }}>SUBSCRIBE</button>
                        
                    </div>

                </div>

            </Container>

            <Modal centered show={subscribeModal} fullscreen={ device.deviceType ===DeviceType.DESKTOP ? "false" : true } dialogClassName={"subscribe-modal"}>
                 <Modal.Body>
                    <div className={"subscribe-modal-body"}>
                        <button className={"close-btn"} onClick={() => {
                            setSubscribeModal(false);
                        }}><i className="bi bi-x-lg"></i></button>

                        <SubscribeForm />
                    </div>
                 </Modal.Body>
                 
            </Modal>

            <EventRegistrationForm eventCode="NJMAY2025" />

            
        </>
    );

}

export default Main;